import React from 'react';
import IconButton from 'material-ui/IconButton';
import PropTypes from 'prop-types';

export const NavSamplesActionButton = ({ disabled, Icon, actionMethod }) => (
  <IconButton disabled={disabled} onClick={actionMethod}>
    {Icon}
  </IconButton>
);

NavSamplesActionButton.propTypes = {
  disabled: PropTypes.bool,
  actionMethod: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/components/nav/NavSamplesActionButton.js